"use client"

/**
 * [INPUT]: 依赖 @radix-ui/react-label 的无障碍标签 primitive 与 @/zinnercms-design-system/lib/utils 的 cn
 * [OUTPUT]: 对外提供 Label 组件
 * [POS]: zinnercms-design-system/ui 的表单标签原子，提供高密度工具界面的稳定标签层级
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import * as LabelPrimitive from "@radix-ui/react-label"

import { cn } from "@/zinnercms-design-system/lib/utils"

function Label({
  className,
  ...props
}) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-xs font-semibold leading-none tracking-[-0.01em] text-foreground select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-45 peer-disabled:cursor-not-allowed peer-disabled:opacity-45",
        className
      )}
      {...props} />
  );
}

export { Label }
